import React from 'react';
import { FormattedMessage } from 'react-intl';
import { components } from 'react-select';

export const CustomMenuList = (props, isOptionError) => {
  return (
    <components.MenuList {...props} style={{ margin: 0, padding: 0 }}>
      {!isOptionError && (
        <>
          {props.children}
          <div className="text-gray-500 text-xs powered-by-google">
            <FormattedMessage
              id="shared_components.location-input.google"
              defaultMessage="Results powered by Google"
            />
          </div>
        </>
      )}
      {isOptionError && (
        <div style={{ padding: '72px 16px' }} className="text-center text-wrap text-gray-600">
          <div className="heavy">
            <FormattedMessage
              id='shared_components.location-input.noLocation'
              defaultMessage="We don't recognize that location"
            />
          </div>
          <div>
            <FormattedMessage
              id='shared_components.location-input.noLocation-subheader'
              defaultMessage="Confirm your spelling is correct or try a different location."
            />
          </div>
        </div>
      )}
    </components.MenuList>
  );
};
